import React from 'react';


const FooterLeft = () =>(
    
        <>                
            <section className="footer__socials">
                <h3>Descubre <br />nuestras redes</h3>
                <ul>
                    <li>
                        <a href="https://facebook.com" className="footer__socials-icon" target="blank">
                            <svg version="1.1" className="iconFacebook" id="facebook" x="0px" y="0px"
                                viewBox="0 0 16 16"><path className="st0" d="M16,8c0-4.4-3.6-8-8-8S0,3.6,0,8c0,4,2.9,7.3,6.7,7.9v-5.6h-2V8h2V6.2c0-2,1.2-3.1,3-3.1c0.9,0,1.8,0.2,1.8,0.2
                                v2h-1c-1,0-1.3,0.6-1.3,1.2V8h2.2L11,10.3H9.1V16C13.1,15.4,16,12,16,8z"/>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://twitter.com" className="footer__socials-icon forTwitter" target="blank">
                            <svg version="1.1" className="iconInstagram" id="iconInstagram" x="0px" y="0px"
                                viewBox="0 0 15 15">
                                <path className="st0" d="M3.2,14.3H0V4.8h3.2V14.3z M1.6,3.6C0.7,3.6,0,2.9,0,2s0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6
                                C3.2,2.9,2.5,3.6,1.6,3.6z M14.6,14.3h-3V9.7c0-1.1,0-2.5-1.6-2.5c-1.6,0-1.8,1.2-1.8,2.4v4.7h-3V4.8H8v1.3h0
                                c0.4-0.7,1.4-1.5,2.9-1.5c3.1,0,3.7,2,3.7,4.5V14.3z"/>
                            </svg>

                        </a>
                    </li>
                    <li><a href="https://instagram.com" className="footer__socials-icon forInstagram" target="blank">
                            <svg version="1.1" className="iconTwitter" id="iconTwitter" x="0px" y="0px"
                                viewBox="0 0 16 16"><path className="st0" d="M12.3,2.8c-0.2,0-0.4,0.1-0.5,0.2c-0.2,0.1-0.3,0.3-0.4,0.4c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.2,0.1,0.4,0.3,0.5
                                c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.2-0.3,0.2-0.5c0-0.3-0.1-0.5-0.3-0.7
                                C12.8,2.9,12.5,2.8,12.3,2.8z M16,4.7c0-0.7-0.1-1.3-0.4-1.9c-0.2-0.5-0.5-1-0.9-1.4c-0.4-0.4-0.9-0.7-1.4-0.9
                                C12.6,0.2,12,0.1,11.3,0C10.4,0,10.2,0,8,0S5.6,0,4.7,0C4,0.1,3.4,0.2,2.8,0.4c-0.5,0.2-1,0.5-1.4,0.9C0.9,1.7,0.6,2.2,0.4,2.8
                                C0.2,3.4,0.1,4,0,4.7C0,5.6,0,5.8,0,8s0,2.4,0,3.3c0,0.7,0.1,1.3,0.4,1.9c0.2,0.5,0.5,1,0.9,1.4c0.4,0.4,0.9,0.7,1.4,0.9
                                C3.4,15.8,4,15.9,4.7,16c0.8,0,1.1,0,3.3,0s2.4,0,3.3,0c0.7,0,1.3-0.1,1.9-0.4c0.5-0.2,1-0.5,1.4-0.9c0.4-0.4,0.7-0.9,0.9-1.4
                                c0.2-0.6,0.4-1.3,0.4-1.9c0-0.8,0-1.1,0-3.3S16,5.6,16,4.7z M14.5,11.2c0,0.5-0.1,1-0.3,1.5c-0.1,0.3-0.3,0.7-0.6,0.9
                                c-0.3,0.3-0.6,0.5-0.9,0.6c-0.5,0.2-1,0.3-1.5,0.3c-0.8,0-1.1,0-3.2,0s-2.4,0-3.2,0c-0.5,0-1.1-0.1-1.6-0.2
                                c-0.3-0.1-0.6-0.3-0.9-0.6c-0.3-0.3-0.5-0.6-0.6-0.9c-0.2-0.5-0.3-1-0.3-1.5c0-0.8,0-1.1,0-3.2s0-2.4,0-3.2c0-0.5,0.1-1,0.3-1.5
                                c0.1-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.5-0.5,0.9-0.6c0.5-0.2,1-0.3,1.5-0.3c0.8,0,1.1,0,3.2,0s2.4,0,3.2,0c0.5,0,1,0.1,1.5,0.3
                                c0.4,0.1,0.7,0.4,1,0.6c0.3,0.2,0.5,0.5,0.6,0.9c0.2,0.5,0.3,1,0.3,1.5c0,0.8,0,1.1,0,3.2S14.6,10.4,14.5,11.2z M8,3.9
                                c-0.8,0-1.6,0.2-2.3,0.7C5,5,4.5,5.7,4.2,6.4C3.9,7.2,3.8,8,4,8.8c0.2,0.8,0.6,1.5,1.1,2.1c0.6,0.6,1.3,1,2.1,1.1
                                c0.8,0.2,1.6,0.1,2.4-0.2c0.7-0.3,1.4-0.8,1.8-1.5c0.5-0.7,0.7-1.5,0.7-2.3c0-0.5-0.1-1.1-0.3-1.6c-0.2-0.5-0.5-1-0.9-1.3
                                c-0.4-0.4-0.8-0.7-1.3-0.9C9.1,4,8.5,3.9,8,3.9z M8,10.7c-0.5,0-1-0.2-1.5-0.4C6.1,9.9,5.7,9.5,5.5,9C5.3,8.5,5.3,8,5.4,7.5
                                c0.1-0.5,0.4-1,0.7-1.4C6.5,5.7,7,5.5,7.5,5.4C8,5.3,8.5,5.3,9,5.5c0.5,0.2,0.9,0.5,1.2,1c0.3,0.4,0.4,1,0.4,1.5
                                c0,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.9S9.3,10.3,9,10.5C8.7,10.6,8.3,10.7,8,10.7z"/>
                            </svg>
                        </a>
                    </li>
                </ul>
            </section>
        </>
    )

export default FooterLeft;